/** @format */

import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { DeviceService } from '@shared/data-access/services';
import { BreakPoint } from '@shared/data-access/enums';

@Component({
	selector: 'clp-breadcrumb',
	templateUrl: './breadcrumb-category.component.html',
	styleUrl: './breadcrumb-category.component.scss',
	standalone: false
})
export class BreadcrumbCategoryComponent implements OnInit {
	@Input() breadcrumbs: any;

	@Input() title: string;

	/**
	 * @type boolean
	 *
	 * @description
	 * Boolean to check if mobile or larger breakpoint
	 */
	isMobileView = true;

	constructor(
		@Inject(PLATFORM_ID) protected platformId: any,
		private deviceService: DeviceService
	) {}

	ngOnInit() {
		if (this.breadcrumbs[0].name.toLowerCase() === 'home') {
			this.breadcrumbs.splice(0, 1);
		}

		// Check the current runtime context
		if (isPlatformBrowser(this.platformId)) {
			// Check the breakpoint
			this.onResize();
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		// Check the breakpoint
		if (
			this.deviceService.getDeviceBreakPoint() === BreakPoint.EXTRASMALL ||
			this.deviceService.getDeviceBreakPoint() === BreakPoint.SMALL ||
			this.deviceService.getDeviceBreakPoint() === BreakPoint.MEDIUM
		) {
			this.isMobileView = true;
		} else {
			this.isMobileView = false;
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	trackByFn(index: number, _item: any): number {
		return index;
	}
}
